import './BackgroundImages.scss';

class BackgroundImages {

	constructor(node) {
		this.node = node;
	}

	init() {
		console.log('BackgroundImages');
	}

}

if (typeof JSModules === "object") {
	JSModules['BackgroundImages'] = BackgroundImages;
} else {
	// initialize section
	let section = new BackgroundImages;
	section.init();
}

export default BackgroundImages;
